import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from '../../reducers/auth';
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import { Container, Row, Col } from "react-bootstrap";

const FeaturedProduct = (props) => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const navigate = useNavigate();
  const loginStatus = useSelector(isLoggedIn);
  const [imgSrc, setImgSrc] = useState(null);
  const [currentColor, setCurrentColor] = useState(null);
  var logosObj = (props.product.logos) ? JSON.parse(props.product.logos) : {};
  var currentLogo = {};
  var logoPrice = 0;

  const imageOver = (item) => {
    setImgSrc(item.modelImage);
    setCurrentColor(item);
    for (var i = 0; i < logosObj.length; i++) {
      if (item.colorId === logosObj[i].colorId) {
        currentLogo = logosObj[i].logos[0];
        console.log("CURRENTLOGO:", logosObj[i].logos[0]);
        break;
      }
    }
  }

  let featuredColor = null;
  if (props.product.featuredColor != null) {
    for (var i = 0; i < props.product.colors.length; i++) {
      if (props.product.colors[i].colorId === props.product.featuredColor) {
        featuredColor = props.product.colors[i];
        for (var j = 0; j < logosObj.length; j++) {
          if (featuredColor.colorId === logosObj[j].colorId) {
            currentLogo = logosObj[j].logos[0];
            console.log("CURRENTLOGO:", logosObj[j].logos[0]);
            break;
          }
        }
      }
    }
  }

  if (featuredColor === null) {
    featuredColor = props.product.colors[0];
    for (var i = 0; i < logosObj.length; i++) {
      console.log("COLORTEST", logosObj);
      if (props.product.colors[0].colorId === logosObj[i].colorId) {
        currentLogo = logosObj[i].logos[0];
        console.log("CURRENTLOGO:", logosObj[i].logos[0]);
        break;
      }
    }

  }
  const removeItem = () => {
    props.removeFeaturedItem(props.product.id);
  }

  return (
    <Col xs={12} sm={6} md={4} lg={2} style={{paddingRight: 4, paddingLeft: 4, paddingBottom: 4, paddingTop: 4}}>
      <div class="product">
        <div className="main-image-container modelImage">
          <div style={{ display: "inline-block", position: "relative" }}>
            <img src={props.product?.logo?.imageUrl ? props.product?.logo?.imageUrl : props.product?.colors[0].modelImage} width="100%"></img>
            {props.product?.logo?.logo && <img className="logo-image" src={apiUrl + props.product.logo.logo.imageUrl} width={props.product.logo.logo.width + '%'} style={{ height: props.product.logo.logo.height + '%', left: props.product.logo.logo.x + '%', top: props.product.logo.logo.y + '%', transform: 'rotate(' + props.product.logo.logo.rotate + 'deg)' }} />}
          </div>
        </div>

        <div class="title">{props.product.title}</div>
        {loginStatus && (
          <div class="price">
            ${(props.product.costSingle2X + logoPrice).toLocaleString(undefined, { maximumFractionDigits: 2 })}
          </div>
        )}
        <div style={{display: "flex", height: "100%"}}>
          <div style={{width: "100%", textAlign: "center", alignSelf: "flex-end"}}>
            <Button onClick={removeItem}>Remove</Button>
          </div>
          </div>
      </div>
    </Col>
  );
};

export default FeaturedProduct; 